import restApiInvoice from "../http-common-delivery";
import session from "./session";

export default class InvoicesApi {

    signIn() {
        return restApiInvoice({
            method: 'post',
            url: '/api/authentication/sign-in',
            data: {
                username: "321dostava",
                password: "sloba123"
            }
        });
    }

    sendInvoice(xml, id, name, time, sendToCir) {
        // const formData = new FormData();
        // formData.append("file", xml);
        return restApiInvoice({
            method: 'post',
            url: '/api/ubl?requestId=' + id + '&ApiKey=' + session.getApiKeyInvoice() + "&fileName="+name+"&uploadTime="+time + "&sendToCir="+sendToCir,
            headers: {
                'accept': 'application/json, text/plain',
                'ApiKey': session.getApiKeyInvoice(),

                'Content-Type': 'application/xml',
                'Authorization': 'Bearer ' + session.getTokenInvoice()
            },
            data: xml
        });
    }

    getSalesInvoiceJSON(id) {
        return restApiInvoice({
            method: 'get',
            url: '/api/invoices/efaktura/sales-invoices/' + id + "?ApiKey=" + session.getApiKeyInvoice(),
            headers: {
                'accept': 'application/json, application/xml, text/plain',
                'Content-Type': 'application/xml',
                'Authorization': 'Bearer ' + session.getTokenInvoice()
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/apiInvoices.js